import { getMobileAppDetails } from '@scouts/helpers'
import {
    Button,
    Flexer,
    ModalActionsLegacy as ModalActions,
    ModalBodyLegacy as ModalBody,
    ModalFooterLegacy as ModalFooter,
    ModalHeaderLegacy as ModalHeader,
    ModalLegacy as Modal,
    ModalTitleLegacy as ModalTitle,
    Paragraph,
} from '@scouts/ui'

const { getShouldUpdateApp, isIos, isAndroid } = getMobileAppDetails()

const messages = {
    heading: 'Actualizar aplicación',
    body: 'Hemos lanzado una nueva versión de la aplicación. Actualízala para seguir usándola.',
    btnAppStore: 'Actualizar en App Store',
    btnGooglePlay: 'Actualizar en Google Play',
}

const links = {
    appStore: 'https://apps.apple.com/es/app/id6670172092',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.taxscouts.es.customer',
}

export const MobileVersionUpdateModal = ({ mobileAppTargetVersion }: { mobileAppTargetVersion: string }) => {
    if (!getShouldUpdateApp(mobileAppTargetVersion)) return null

    return (
        <Modal>
            <ModalHeader>
                <ModalTitle>{messages.heading}</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <Paragraph>{messages.body}</Paragraph>
            </ModalBody>
            <ModalFooter>
                <ModalActions>
                    {isIos && (
                        <Button
                            isMobileFullWidth
                            as="a"
                            size="large"
                            href={links.appStore}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Flexer justifyCenter>{messages.btnAppStore}</Flexer>
                        </Button>
                    )}

                    {isAndroid && (
                        <Button
                            isMobileFullWidth
                            as="a"
                            size="large"
                            href={links.googlePlay}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Flexer justifyCenter>{messages.btnGooglePlay}</Flexer>
                        </Button>
                    )}
                </ModalActions>
            </ModalFooter>
        </Modal>
    )
}
